module.exports = "https://cdn.hellotech.com/client-assets/thermostats_mobile_7f5213985790555f7a53b108fd30e442.webp";